type CardKickerProps = {
  /** Optional additional styling for the container*/
  className?: string;
  /** The text to display as kicker. */
  text?: string;
  /** The separator to display between the kicker and the text. */
  separator?: string;
};

/**
 * CardKicker component that renders a kicker text.
 * It is used to display additional information or context for the card.
 */
const CardKicker = ({
  className,
  text,
  separator,
}: CardKickerProps): React.ReactElement => {
  return (
    <div data-testid="card-kicker-component" className={className}>
      {separator ? <span>{separator}</span> : null}

      <span>{text}</span>
    </div>
  );
};

export default CardKicker;
